import { Component, OnInit, Input } from '@angular/core';
import { NotificationsService } from '@app/providers/notifications/notifications.service';
import { UserService } from '@app/providers/user/user.service';
import { takeWhile } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';

@Component({
    selector: 'ea-notifications-header',
    templateUrl: './ea-notifications-header.component.html',
    styleUrls: ['./ea-notifications-header.component.scss'],
    standalone: false
})
export class EaNotificationsHeaderComponent implements OnInit {
  /* @Input() on: boolean = true;
  @Input() name: string = 'pinel';
  @Output() prToggle = new EventEmitter(); */
  @Input() types;
  alive: boolean = true;
  user: UserAuthentified;
  _ = _;

  constructor(
    private router: Router,
    private userService: UserService,
    public notificationsService: NotificationsService,
  ) {}

  ngOnInit() {
    this.userService
      .getUser()
      .pipe(takeWhile(() => this.alive))
      .subscribe(res => {
        if (res) {
          this.user = res;
        }
      });
  }

  openPage(url: string) {
    this.router.navigate([url]);
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
